module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-container"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "stats-col",
    attrs: {
      "span": 6
    }
  }, _vm._l((_vm.statsData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "stats-card"
    }, [_c('div', {
      staticClass: "stats-item"
    }, [_c('span', {
      staticClass: "stats-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "stats-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', {
      staticClass: "stats-unit"
    }, [_vm._v(_vm._s(item.unit))])])])
  }), 1), _vm._v(" "), _c('el-col', {
    staticClass: "map-col",
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "map-card"
  }, [_c('div', {
    staticClass: "map-title"
  }, [_vm._v("宜春市企业分布地图")]), _vm._v(" "), _c('div', {
    staticClass: "map-container",
    attrs: {
      "id": "jiangxi-map"
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "stats-col",
    attrs: {
      "span": 6
    }
  }, _vm._l((_vm.extraStatsData), function(item, index) {
    return _c('el-card', {
      key: index,
      staticClass: "stats-card"
    }, [_c('div', {
      staticClass: "stats-item"
    }, [_c('span', {
      staticClass: "stats-label"
    }, [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('span', {
      staticClass: "stats-value"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('span', {
      staticClass: "stats-unit"
    }, [_vm._v(_vm._s(item.unit))])])])
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171036fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Main.vue
// module id = 821
// module chunks = 2